<mat-form-field class="time-filter">
  <mat-label>Date Range</mat-label>
  <mat-select appearance="fill" [(ngModel)]="selectedTimeFilter">
    <mat-option *ngFor="let time of timeFilters" (click)="filterByTime(time)" [value]='time'>
      {{time}}
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field class="report-filter">
  <mat-label>Report</mat-label>
  <mat-select appearance="fill" [(ngModel)]="selectedReportName">
    <mat-option *ngFor="let report of reports" (click)="filterByReport(report)" [(value)]="report.name">
      {{report.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field class="bac-filter">
  <mat-label>DUNS</mat-label>
  <input type="text" matInput aria-label="Number" [formControl]="dealerFilterControl" [matAutocomplete]="dealer"
    [(ngModel)]="selectedVendorId">
  <button mat-button *ngIf="selectedVendorId" matSuffix mat-icon-button aria-label="Clear" (click)="filterByDealer('')">
    <mat-icon>close</mat-icon>
  </button>
  <mat-autocomplete #dealer="matAutocomplete" (optionSelected)='filterByDealer($event.option.value)'>
    <mat-option *ngFor="let option of dealerSearchValues" [value]="option.vendorId">
      {{option.vendorId}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
<kendo-chart *ngIf="!isLoading && !byUser">
  <kendo-chart-tooltip>
  </kendo-chart-tooltip>
  <kendo-chart-legend position="bottom" orientation="horizontal" [visible]="false"></kendo-chart-legend>
  <kendo-chart-series>
    <kendo-chart-series-item name="Total Views" type="line" [data]="chartData" categoryField="Date" field="count"
      [style]="'smooth'" color="#5ee64c" width="3">
    </kendo-chart-series-item>
  </kendo-chart-series>
  <kendo-chart-category-axis>
    <kendo-chart-category-axis-item [maxDivisions]="10" type="date">
    </kendo-chart-category-axis-item>
  </kendo-chart-category-axis>
</kendo-chart>
<div *ngIf="!isLoading && byUser">
  <app-data-table [displayedColumns]="columns" [tableData]="tableData" [initSortColumn]="0" [initSortDirection]="'desc'"
    [selectable]="false">
  </app-data-table>
</div>

